// CustomDomainContentRouter.jsx
import { Routes, Route } from 'react-router-dom';
import CustomDomainBookViewer from '../components/books/CustomBookViewer';
import TaskDirectAccess from '../components/leitner/TaskDirectAccess';
import TasksHub from '../components/leitner/TasksHub';

const CustomDomainContentRouter = ({ bookData }) => {
  const bookId = bookData?.id;
  const basePath = bookData?.path || bookData?.customPath || '';

  if (basePath) {
    return (
      <Routes>
        <Route path={`/${basePath}`} element={<CustomDomainBookViewer bookData={bookData} bookId={bookId} />} />
        <Route path={`/${basePath}/tasks`} element={<TasksHub bookData={bookData} bookId={bookId} />} />
        <Route path={`/${basePath}/tasks/:taskId`} element={<TaskDirectAccess bookData={bookData} bookId={bookId} />} />
        <Route path={`/${basePath}/chapters/:chapterId`} element={<CustomDomainBookViewer bookData={bookData} bookId={bookId} />} />
        <Route path="*" element={<CustomDomainBookViewer bookData={bookData} bookId={bookId} />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<CustomDomainBookViewer bookData={bookData} bookId={bookId} />} />
      <Route path="/tasks" element={<TasksHub bookData={bookData} bookId={bookId} />} />
      <Route path="/tasks/:taskId" element={<TaskDirectAccess bookData={bookData} bookId={bookId} />} />
      <Route path="/chapters/:chapterId" element={<CustomDomainBookViewer bookData={bookData} bookId={bookId} />} />
      <Route path="*" element={<CustomDomainBookViewer bookData={bookData} bookId={bookId} />} />
    </Routes>
  );
};

export default CustomDomainContentRouter;